import { COLORS } from 'consts/colors'
import styled, { css } from 'styled-components'
import { Text } from 'common-components'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { RADII } from 'styles/consts'

interface IStyleItemProps {
  $isSelected: boolean
  $isDefaultStyle?: boolean
}

const styleItemPseudoElements = css`
  &::after {
    background: linear-gradient(360deg, #1e2539 0%, rgba(30, 37, 57, 0) 90.91%);
    content: '';
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 50%;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  }

  &::before {
    z-index: 2;
    content: '';
    position: absolute;
    inset: 0;
    border: 2px solid ${COLORS.primaryDark};
    border-radius: ${RADII.item};
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.2s linear;
  }
`

export const StyleName = styled(Text)`
  opacity: 0;
  position: absolute;
  transition: opacity 0.3s ease-in-out;
  margin-bottom: 8px;
  z-index: 2;
`
export const StyleItem = styled.div<IStyleItemProps>`
  position: relative;
  width: 128px;
  height: 128px;
  border-radius: ${RADII.item};
  overflow: hidden;
  background-color: ${COLORS.primaryExtraLight};

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;

  cursor: pointer;

  ${styleItemPseudoElements}

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      &::before {
        opacity: 1;
      }
    `}

  &:hover {
    ${StyleName} {
      opacity: 1;
    }
    ${({ $isDefaultStyle }) =>
      !$isDefaultStyle &&
      css`
        &::after {
          opacity: 1;
        }
      `}
  }

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: auto;
    height: auto;
    aspect-ratio: 1 / 1;
  }
`

export const StyleImage = styled.img<{
  $isLoading?: boolean
}>`
  object-fit: cover;
  height: 100%;
  opacity: ${({ $isLoading }) => ($isLoading ? 0 : 1)};
  transition: opacity 0.3s ease-in-out;
`

export const AISkeletonItemContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`
